import { render } from "./Admin.Organisations.ListDatatable.vue?vue&type=template&id=399f18e0"
import script from "./Admin.Organisations.ListDatatable.vue?vue&type=script&lang=js"
export * from "./Admin.Organisations.ListDatatable.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__